<script>
export default {
  props: {
    employeeInformation: {
      required: true,
      type: Array,
    },
    loading: {
      required: true,
      type: Boolean
    }
  }
}
</script>

<template>
  <v-skeleton-loader
    v-if="loading"
    type="image"
  />
  <v-card
    v-else
    height="100%"
    class="flex d-flex flex-column"
    style="border-width: 0"
  >
    <v-card-title class="primary white--text py-2 justify-space-between">
      <div>
        {{ $t('detail.employee_info') }}
      </div>
    </v-card-title>
    <v-card-text class="pb-1 mt-2">
      <v-row
        v-for="(employee, index) in employeeInformation"
        :key="`${index}-${employee}`"
        class="ma-0 pt-0"
      >
        <v-col
          cols="6"
          class="py-0"
        >
          {{ $t(`employee.${employee.label}`) }} :
        </v-col>
        <v-col
          cols="6"
          class="py-1"
        >
          <div
            class="primary--text"
          >
            {{ employee.value }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>
